import { useParams } from 'react-router-dom';
import { Language } from '../types';
import { FirebaseProvider } from '../contexts/FirebaseContext';
import { useSurveyResults } from '../hooks/useSurveyResults';
import { useTranslation } from '../hooks/useTranslation';
import Chart from './charts/Chart';
import './WebResultsPage.css';

function WebResultsContent() {
  const { lang } = useParams<{ lang: Language }>();
  const { stats, loading } = useSurveyResults();
  const { translations } = useTranslation();

  const currentLang = lang || 'en';
  const questions = Object.keys(translations.questions[currentLang]);
  const answers = Object.values(translations.questions[currentLang]) as string[][];

  if (loading) {
    return (
      <div className="web-loading">
        <p>Loading results...</p>
      </div>
    );
  }

  if (!stats || !stats.responsesByQuestion) {
    return (
      <div className="web-error">
        <p>No data available</p>
      </div>
    );
  }

  return (
    <div className="web-results">
      <header className="web-header">
        <h1>{translations.ui[currentLang].title}</h1>
        <h2>{translations.ui[currentLang].subtitle}</h2>
        <p>{stats.totalResponses} {translations.ui[currentLang].tally}</p>
      </header>

      <div className="web-charts-grid">
        {questions.map((questionText, index) => {
          const questionCount = stats.responsesByQuestion[index] || {};
          return (
            <div key={index} className="web-chart-container">
              <Chart
                questionNumber={index}
                questionText={questionText}
                answers={answers[index]}
                count={questionCount}
                totalRespondents={stats.totalResponses}
                showCount={false}
                variant="web"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function WebResultsPage() {
  return (
    <FirebaseProvider>
      <WebResultsContent />
    </FirebaseProvider>
  );
}

export default WebResultsPage;